import SliderCard from "../../Molecules/SliderCard/SliderCard";
import FS_ABOUT_CARLOSGONZALES_IMAGEN from "../../../assets/img/FS-ABOUT-CARLOSGONZALES-IMAGEN.png";
import "./ReactSlider.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import content from "../../Pages/About/content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";

const ReactSlider = () => {
	const {language} = useLanguageCtx();

  return (
		<div className="reactSlider-grid-design mt-80">
			<div className="reactSlider-container max-width">
				<Carousel
					autoPlay={true}
					showStatus={false}
					infiniteLoop={true}
					interval="3500"
					showThumbs={false}
					className="reactSlider--carousel"
				>
					<div className="all-width-height flex center-content-items">
						<SliderCard
							name="Carlos González"
							charge="TI Manager Tracker GPS Venezuela"
							personImg={FS_ABOUT_CARLOSGONZALES_IMAGEN}
							rightText={content[language].sliderText}
						/>
					</div>
					<div className="all-width-height flex center-content-items">
						<SliderCard
							name="Carlos González"
							charge="TI Manager Tracker GPS Venezuela"
							personImg={FS_ABOUT_CARLOSGONZALES_IMAGEN}
							rightText={content[language].sliderText}
						/>
					</div>
				</Carousel>
			</div>
			<div className="reactSlider-blue-background"></div>
		</div>
	);
};

export default ReactSlider;
